// import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { getConnectInstance, disconnectInstance, getUuid } from "@/apis/app.js"
const { MciSign, redfingerV2 } = window;
// import { Dialog } from 'vant';

const state = {
  mciSign:null,
  option: {
    appKey: '47db85008ffe437593473ef1021635ad', // 请从客户开放平台首页查询
    appSecret: '7f2ca72a93997c95fbbaf30b19c430f8', // 请从客户开放平台首页查询
    desKey: 'e25f99b185a434175ec1a269e514265c', // 请从客户开放平台首页查询
    baseUrl: 'https://paas.armvm.com'
  },
  idleInstance:[],
  deviceInfo:null,
  uuid: '0',
  appId:12   // 微信 11 land 12  腾讯会议 14
}

const getters = {
  mciSign: (state) => state.mciSign,
  idleInstance: (state) => state.idleInstance,
  deviceInfo: (state) => state.deviceInfo,
  uuid: (state) => state.uuid,
  appId: (state) => state.appId
};

const mutations = {
  setMciSign: (state, mciSign) => {
    state.mciSign = mciSign
  },
  setDeviceInfo(state,deviceInfo){
    state.deviceInfo = deviceInfo;
  },
  setUuid(state, uuid){
    state.uuid = uuid;
  },
  setIdleInstance: (state, idleInstance) => {
    state.idleInstance = idleInstance
  },
}

const actions = {
  initMciSign({ state,commit }) {
    // 初始化paas api sdk
    if (state.mciSign !== null) return ;
    let mciSign = new MciSign(state.option);
    commit('setMciSign',mciSign)
  },
  async getUuid({ commit }){
    let params = {}
    let res = await getUuid(params);
    let uuid = res.data.data.uuid;
    commit('setUuid', uuid);
    window.localStorage.setItem('uuid',uuid);
  },
  async getConnect({ state,commit, dispatch }){
    let existUuid = window.localStorage.getItem('uuid');
    if(existUuid){
      commit('setUuid', existUuid);
    }else{
      await dispatch('getUuid');
    }
    // console.log(navigator)
    let params = {
      uuid: state.uuid, // uuid 必填
      online_time: 2 * 60 * 60, // 申请试玩时长 必填 单位为秒 
      app_id: state.appId, // 应用id, 从客户开放平台应用管理页面查询 可选
    }
    // online_time: 3600, // 申请试玩时长 必填 
    // pad_code:'VM010151120021',
    // verison:navigator.appVersion,
    // info:navigator.platform
    let res = await getConnectInstance(params);
    // console.log(res)
    if(res.data.data && res.data.data.code === 2004){
      // 2004 uuid非法和过期
      return Promise.resolve({status:false,msg:'uuid 已过期，正在重新生成', showMsg:false, newIns:true});
    }
    if(res.data.data && res.data.data.code === 2001){
      await dispatch('disconnectInstance', res.data.data.data);
        return Promise.resolve({status:false,msg:'正在重新申请实例',newIns:true,showMsg:false})
      // return Dialog.confirm({
      //   title: '提示',
      //   message:
      //     '申请的实例未释放，是否释放？',
      //   confirmButtonText: '确 定',
      //   cancelButtonText: '取 消'
      // }).then(async() => {
      //   await dispatch('disconnectInstance', res.data.data.data);
      //   return Promise.resolve({status:false,msg:'正在重新申请实例',newIns:true,showMsg:false})
      // })
      // .catch(() => {
      //   return Promise.resolve({status:false,msg:'已取消'})
      // });
      
    }else{
      let deviceInfo = res.data;
      commit('setDeviceInfo',deviceInfo);
      return deviceInfo.resultCode === 0?Promise.resolve({status:true}):Promise.resolve({status:false, msg:''});
    }
    

    // let param = {
    //   uuid: state.uuid, // uuid 必填
    //   onlineTime: 3600, // 申请试玩时长 必填
    //   appId: state.appId, // 应用id, 从客户开放平台应用管理页面查询 可选
    //   // padCode:' VM010122068133'
    // }
    // return new Promise((resolve)=>{
    //   // 调用设备绑定申请接口
    //   state.mciSign.execute(
    //   state.mciSign.ApiEnum.DEVICE_CONNECT,
    //   param,
    //   (deviceInfo) => {
    //     commit('setDeviceInfo',deviceInfo);
    //     console.log(deviceInfo)
    //     deviceInfo.resultCode === 0?resolve(true):resolve(false);
    //   })
    // })
  },
  // async getUuid({ commit }){
  //   const fp = await FingerprintJS.load();
  //   const result =await fp.get();
  //   commit('setUuid',result.visitorId)
  // },
  getInstanceList({ state,commit }) {
    let param = {
      page: 1,
      rows: 92
    };
    return new Promise((resolve)=>{
      state.mciSign.execute(state.mciSign.ApiEnum.PAD_INFOS, param, (res) => {
        if (res.code === 0) {
          let idleInstance = res.data.pageData.filter(
            (i) => i.padStatus === '0'
          );
          commit('setIdleInstance',idleInstance)
          resolve(true)
        } else {
          console.error(res.msg);
          resolve(false)
        }
      });
    })
  },
  async disconnectInstance({ state },{pad_code,app_id}){
    let params = {
      uuid: state.uuid,
      appId: app_id,
      pad_code: pad_code
    };
    redfingerV2.stop();
      // 调用设备解绑释放接口
      let res = await disconnectInstance(params);
      res.resultCode === 0 ? Promise.resolve(true) : Promise.resolve(false);
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
